import React from "react";
import classNames from "classnames";
import {
    EmailDetailsFields,
    ScheduleEmailFields,
    SendEmailFields,
} from "./EmailSectionFields";
import { INVOICE_SECTION_ANCHORS } from "./invoiceSectionAnchors";
import styles from "./SidePanel.module.scss";

// Email subject/body and send options (attach PDF, schedule email), edited
// from the details step. Same form-state fields the send step edits, so the
// two stay in sync.
export const EmailSection: React.FC = () => (
    <section
        id={INVOICE_SECTION_ANCHORS.email}
        className={classNames(styles.panelSection, styles.stepSection)}
    >
        <div className={styles.panelSectionBody}>
            <div className={styles.sectionCard}>
                <div className={styles.unframedSection}>
                    <div className={styles.cardTitle}>Send email</div>
                    <SendEmailFields />
                </div>
            </div>
            <div className={styles.sectionCard}>
                <div className={styles.unframedSection}>
                    <div className={styles.cardTitle}>Details</div>
                    <EmailDetailsFields />
                </div>
            </div>
            <div className={styles.togglesCard}>
                <ScheduleEmailFields
                    switchClassName={classNames(
                        styles.sectionTitleToggleRow,
                        styles.scheduleToggleRow,
                    )}
                    bodyClassName={styles.togglesCardBody}
                />
            </div>
        </div>
    </section>
);
